import { PageContent, SideMenu } from "@components";
import { CONTENT_TYPES } from "@constants";
import { IPage, IPageContentDefault, PageContext } from "@types";
import {
    componentMapper,
    isFirstSection,
    shortenTypename,
} from "@utils/componentMapper";
import { graphql } from "gatsby";
import React, { useMemo, useState } from "react";

interface Props extends PageContext {
    data: {
        page: IPage;
    };
}

const Page = ({ data: { page } }: Props) => {
    const { pageContent, hasSidebar } = page;
    const typedContent = pageContent as IPageContentDefault;

    const [closeSwitchInvestorSection, setCloseSwitchInvestorSection] =
        useState(false);

    const content = useMemo(() => {
        if (!closeSwitchInvestorSection) return typedContent?.content;

        return typedContent?.content?.filter(
            item =>
                shortenTypename(item) !==
                CONTENT_TYPES.SWITCH_INVESTOR_TYPE_SECTION,
        );
    }, [closeSwitchInvestorSection, typedContent?.content]);

    return (
        <>
            {typedContent && (
                <PageContent>
                    {componentMapper(typedContent?.hero, {
                        landingPage: page.slug === "home",
                    })}
                    {content?.map((item, idx) => {
                        let options: any =
                            shortenTypename(item) ===
                            CONTENT_TYPES.SWITCH_INVESTOR_TYPE_SECTION
                                ? {
                                      onClose: () =>
                                          setCloseSwitchInvestorSection(true),
                                  }
                                : null;

                        if (isFirstSection(item, idx)) {
                            options = options
                                ? { ...options, isFirstSection: true }
                                : { isFirstSection: true };
                        }

                        if (!isFirstSection(item, idx) || !hasSidebar)
                            return componentMapper(item, options, idx);

                        return componentMapper(
                            {
                                ...item,
                                sidebar: <SideMenu />,
                            },
                            options,
                            idx,
                        );
                    })}
                </PageContent>
            )}
        </>
    );
};

export default Page;

export const query = graphql`
    query ($id: String!, $investor: String) {
        page: contentfulComposePage(id: { eq: $id }) {
            id
            slug
            pageTheme
            title
            hasSidebar
            locales
            pageContent(investor: $investor) {
                ... on ContentfulPageContentContent {
                    hero {
                        ...Hero
                        ...HeroCarousel
                    }
                    content {
                        ...GeneralContent
                    }
                }
            }
            pageSeo(investor: $investor) {
                ...SEO
            }
            disablePageForInvestorTypes
            fallbackPage {
                ... on ContentfulComposePage {
                    slug
                }
            }
        }
    }
`;
